module.exports = __webpack_public_path__ + "img/secure.d8068bd5.svg";